import { useUser } from '@auth0/nextjs-auth0/client';
import { isEmpty } from 'lodash';
import { usePostHog } from 'posthog-js/react';
import { useEffect } from 'react';

export function UserPageViewTracking(): JSX.Element {
  const { user } = useUser();
  const posthog = usePostHog();

  useEffect(() => {
    if (!isEmpty(user)) {
      posthog.identify(user.userId as string, {
        id: user.userId as string,
        user_id: user.userId as string,
      });
    }
  }, [user, posthog]);

  useEffect(() => {
    if (!isEmpty(user)) {
      // segment tracking
      if (window.analytics?.identify) {
        window.analytics.identify(user.userId, {
          id: user.userId,
          user_id: user.userId,
          phone: user.phoneNumber,
          firstName: user.firstName,
          lastName: user.lastName,
          state: user.state,
          email: user.email,
        });
      }
    }
  }, [user]);

  return <></>;
}

export default UserPageViewTracking;
